import { FC } from 'react';
import { Pages } from '../../Enums';
import { NavButton } from '../Inputs/NavButton/NavButton';
import { Options } from '../Inputs/Options/Options';
import './Footer.scss';

type Props = {
	page: Pages;
};

/**
 * A component containing the footer elements of the app
 */
export const FooterContainer: FC<Props> = ({ page }) => {
	const Actions: FC = () => {
		switch (page) {
			case Pages.PRODUCTION_PAGE:
				return (
					<>
						<NavButton
							title="Produktion"
							icon="Production"
							isActive={page === Pages.PRODUCTION_PAGE}
							path="/production"
						/>
						<NavButton
							title="Ordrer"
							icon="TemplateIcon"
							path="/productionorderbook"
						/>
						<NavButton
							title="Planlægning"
							icon="TemplateIcon"
							path="/planner"
						/>
					</>
				);
			case Pages.ORDERBOOK_PRODUCTION_PAGE:
				return (
					<>
						<NavButton
							title="Produktion"
							icon="Production"
							path="/production"
						/>
						<NavButton
							title="Ordrer"
							icon="TemplateIcon"
							isActive={page === Pages.ORDERBOOK_PRODUCTION_PAGE}
							path="/productionorderbook"
						/>
						<NavButton
							title="Planlægning"
							icon="TemplateIcon"
							path="/planner"
						/>
					</>
				);

			case Pages.PLANNER_PAGE:
				return (
					<>
						<NavButton
							title="Produktion"
							icon="Production"
							path="/production"
						/>
						<NavButton
							title="Ordrer"
							icon="TemplateIcon"
							path="/productionorderbook"
						/>
						<NavButton
							title="Planlægning"
							icon="TemplateIcon"
							isActive={page === Pages.PLANNER_PAGE}
							path="/planner"
						/>
					</>
				);
			default:
				return (
					<>
						<NavButton
							title="Produktion"
							icon="OrderingIcon"
							isActive={page === Pages.ORDERS_PAGE}
							path="/orders"
						/>
						<NavButton
							title="Spild"
							icon="TrashIcon"
							isActive={page === Pages.WASTE_PAGE}
							path="/waste"
						/>
						<NavButton
							title="Skabelon"
							icon="TemplateIcon"
							isActive={page === Pages.TEMPLATE_PAGE}
							path="/template"
						/>
						<NavButton
							title="Ordrer"
							icon="TemplateIcon"
							isActive={page === Pages.ORDERBOOK_STORE_PAGE}
							path="/store-orders"
						/>
					</>
				);
		}
	};

	return (
		<div className="footer-container">
			<div className="footer-container__log-out">
				<NavButton
					isActive={true}
					title="Log ud"
					icon="Logout"
					path="/authenticate"
				/>
			</div>
			<div className="footer-container__button-group">
				<Actions />
			</div>
			<div className="footer-container__locations">
				<Options />
			</div>
		</div>
	);
};
